import type { ActivityPeriod } from "../../schemas/activity";

export const adminQueryKeys = {
	activityEvents: {
		all: ["activity-events"] as const,
		list: (limit: number, offset: number) => ["activity-events", limit, offset] as const,
	},
	activityRollup: {
		all: ["activity-rollup"] as const,
		period: (period: ActivityPeriod) => ["activity-rollup", period] as const,
	},
	activitySeries: {
		all: ["activity-series"] as const,
		range: (days: number) => ["activity-series", days] as const,
	},
	adminChat: {
		all: ["admin-chat"] as const,
		list: (filters?: {
			roomId?: string;
			gameId?: string;
			senderId?: string;
			search?: string;
			limit?: number;
			offset?: number;
		}) => ["admin-chat", "list", filters ?? {}] as const,
	},
	appVersions: {
		all: ["app-versions"] as const,
	},
	platformCounts: {
		all: ["platform-counts"] as const,
	},
	platformStats: {
		all: ["platform-stats"] as const,
		range: (days: number) => ["platform-stats", days] as const,
	},
	shareLinks: {
		all: ["share-links"] as const,
		list: (params: { limit: number; offset: number }) => ["share-links", "list", params] as const,
	},
} as const;
